module.exports = __webpack_public_path__ + "img/E@2x.41c2ba7c.jpg";